/*
**************************** 
홈페이지 구매 리스트
*****************************
*/

import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";

export default function BuyList() {

    // const CANCLE_URL = "https://bs-l4box.com/cancel";
    // const CANCLE_URL = "http://127.0.0.1:5000/cancel";
    const CANCLE_URL = "/buy/cancel";
    const [userBuyDataList, setUserBuyDataList] = useState([]);
    const [userBuyContentDataList, setUserBuyContentDataList] = useState([]);

    const req = async function (userId) {
        const reqSql = "/api/buy/";
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.data.t_data.length > 0) {
                let copyUserData = [...userBuyDataList];
                copyUserData = res.data.t_data;
                setUserBuyDataList(copyUserData);
            }

            reqContents(userId);
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    const reqContents = async function (userId) {
        const reqSql = "/api/buy/contents";
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.data.t_data.length > 0) {
                let copyUserData = [...userBuyContentDataList];
                copyUserData = res.data.t_data;
                setUserBuyContentDataList(copyUserData);
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    function Unix_timestamp(t) {
        var date = new Date(t * 1000);
        var year = date.getFullYear();
        var month = "0" + (date.getMonth() + 1);
        var day = "0" + date.getDate();
        var hour = "0" + date.getHours();
        var minute = "0" + date.getMinutes();
        var second = "0" + date.getSeconds();
        return year + "-" + month.substr(-2) + "-" + day.substr(-2) + " " + hour.substr(-2) + ":" + minute.substr(-2) + ":" + second.substr(-2);
    }

    const doCancle = async (cell) => {
        const TID = cell.TID;
        const moid = cell.moid;
        const CancelAmt = cell.amt;

        const reqSql = "/api/buy/cancle";
        const params = { TID, moid, CancelAmt };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200) {
                alert("취소신청 되었습니다.");
                const id = sessionStorage.getItem("userId");
                if (Number(id) !== -1 && id !== null) {
                    req(id);
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    useEffect(() => {
        const id = sessionStorage.getItem("userId");
        if (Number(id) !== -1 && id !== null) {
            req(id);
        }
    }, []);

    return (
        <div className="mt-5 pt-2">
            <ol className="breadcrumb">
                <li className="breadcrumb-item active small">구매조회</li>
            </ol>
            <main className="container text-start">
                <div className="my-3 p-3 bg-body rounded shadow-sm">
                    {userBuyDataList.length > 0 ? <h6 className="border-bottom pb-2 mb-0 fw-bold">구매내역</h6> : <h6 className="border-bottom pb-2 mb-0 fw-bold">구매내역이 없습니다.</h6>}
                    {userBuyDataList.map((cell, idx) => {
                        const receiveUser = cell.buyerName + "(" + (cell.target_userName !== "" && cell.target_userName !== cell.buyerName ? cell.target_userName : cell.buyerName) + ")";
                        const receiveAddress = (cell.target_address !== " " && cell.target_address !== cell.address ? cell.target_address : cell.address);
                        let processStatus = "";
                        if (cell.process === -1) {
                            processStatus = "결제 전"
                        } else if (cell.process === 0) {
                            processStatus = "결제 완료"
                        } else if (cell.process === 1) {
                            processStatus = "배송 준비중"
                        } else if (cell.process === 2) {
                            processStatus = "배송 중"
                        } else if (cell.process === 3) {
                            processStatus = "배송 완료"
                        } else if (cell.process === -99) {
                            processStatus = "구매취소 완료"
                        } else {
                            processStatus = "구매취소 신청"
                        }
                        if (processStatus === "결제 전") {
                            return (
                                null
                            );
                        }

                        const days = Number(moment().diff(cell.complete_at, 'days'));
                        return (
                            <div key={idx}>
                                <div className="d-flex text-muted pt-3" >
                                    <svg className="bd-placeholder-img flex-shrink-0 me-2 rounded" width="32" height="32" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#007bff"></rect><text x="50%" y="50%" fill="#007bff" dy=".3em">32x32</text></svg>
                                    <p className="mb-1 small lh-sm pb-3 border-bottom w-100">
                                        <strong className="d-block text-gray-dark">{cell.goodsName}</strong>
                                        <middle>구매자 : {receiveUser}</middle><br></br>

                                        <middle>구매아이디: {cell.moid}</middle><br></br>
                                        <middle>결제금액: {(cell.amt).toLocaleString()}원</middle><br></br>
                                        <middle>구매일시: {cell.complete_at}</middle><br></br>
                                   
                                        <middle className="fs-7 fw-bolder ">상태: {processStatus}</middle>
                                        {cell.reqReserved == "content_package" && days < 8 && cell.process == 0 ? <middle className="d-block text-end">
                                            <a href="#" onClick={() => {
                                                doCancle(cell);
                                            }}>구매취소신청</a>
                                        </middle> : null}
                                        {cell.reqReserved == "content" && days < 8 && cell.process == 0 ? <middle className="d-block text-end">
                                            <a href="#" onClick={() => {
                                                doCancle(cell);
                                            }}>구매취소신청</a>
                                        </middle> : null}
                                        {cell.reqReserved != "content" && cell.reqReserved != "content_package" &&  cell.process === 0 || cell.process == 1 ? <middle className="d-block text-end">
                                            <a href="#" onClick={() => {
                                                doCancle(cell);
                                            }}>구매취소신청</a>
                                        </middle> : null}
                                    </p>
                                </div>
                            </div>
                        )
                    })}

                </div>
                <div className="my-3 p-3 bg-body rounded shadow-sm">
                    {userBuyContentDataList.length > 0 ? <h6 className="border-bottom pb-2 mb-0 fw-bold">콘텐츠 내역</h6> : <h6 className="border-bottom pb-2 mb-0 fw-bold">콘텐츠 내역이 없습니다.</h6>}
                    {userBuyContentDataList.map((cell, idx) => {
                        let durationMsg;
                        if (cell.business_type === -1 || cell.business_type === -2) {
                            durationMsg = "무제한";
                        } else if (cell.business_type === 0) {
                            if (cell.start_date === -1) {
                                durationMsg = "톡톡박스에서 로그인 해 주세요"
                            } else {
                                const start_date_date = moment(Unix_timestamp(cell.start_date)).format("YYYY-MM-DD");
                                const end_date_date = moment(Unix_timestamp(cell.expiration_date)).format("YYYY-MM-DD");
                                durationMsg = start_date_date + "~" + end_date_date;
                            }

                        } else if (cell.business_type === 1) {
                            if (cell.start_date === -1) {
                                durationMsg = "톡톡박스에서 로그인 해 주세요"
                            } else {
                                const start_date_date = moment(Unix_timestamp(cell.start_date)).format("YYYY-MM-DD");
                                const end_date_date = moment(Unix_timestamp(cell.expiration_date)).format("YYYY-MM-DD");
                                durationMsg = start_date_date + "~" + end_date_date;
                            }
                        } else if (cell.business_type === 2) {
                            durationMsg = "콘텐츠에서 쿠폰을 등록해 주세요";
                        } else {

                        }

                        return (
                            <div className="d-flex text-muted pt-3" key={idx}>
                                <svg className="bd-placeholder-img flex-shrink-0 me-2 rounded" width="32" height="32" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="pink"></rect><text x="50%" y="50%" fill="pink" dy=".3em">32x32</text></svg>
                                <p className="mb-1 small lh-sm pb-3 border-bottom w-100">
                                    <strong className="text-gray-dark">{cell.title}</strong><br></br>
                                    <middle>구독기간 : {cell.use_value}일</middle><br></br>
                                    <middle>사용기간 : {durationMsg}</middle><br></br>
                                    <middle>구매일시 : {moment(cell.created_at).format("YYYY-MM-DD HH:mm:ss")}</middle><br></br>
                                    {cell.buy_cancel === 1 ? <middle className="fs-7 fw-bolder ">상태: 구매취소</middle> : null}
                                </p>
                            </div>
                        )
                    })}
                </div>
            </main>
        </div>
    )
}